import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import EditProfileModal from './EditProfileModal';

const ProfileSummaryCard = ({ user, rankName, streakDays, achievements, onProfileUpdate }) => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const displayAchievements = achievements?.length
    ? achievements
    : [{ id: 'empty', name: 'Complete your first day to start earning badges', icon: 'Sparkles', color: 'text-muted-foreground' }];

  return (
    <div className="bg-white/30 backdrop-blur-xl rounded-xl p-4 sm:p-6 border border-white/40 shadow-sm">
      <div className="flex flex-col sm:flex-row items-center sm:items-center gap-4 text-center sm:text-left">
        <div className="relative flex-shrink-0">
          <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden bg-muted">
            <img src={user?.avatar} alt={`${user?.name} profile`} className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success rounded-full border-2 border-card flex items-center justify-center">
            <Icon name="Check" size={12} color="white" />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-1 truncate">{user?.name}</h2>
          <p className="text-muted-foreground text-sm mb-2 truncate">{user?.email}</p>
          <div className="flex items-center justify-center sm:justify-start gap-4 text-sm flex-wrap">
            <div className="flex items-center gap-1">
              <Icon name="Flame" size={16} className="text-orange-500" />
              <span className="text-foreground font-medium">{streakDays ?? 0}/7</span>
              <span className="text-muted-foreground">day streak</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Calendar" size={16} className="text-accent" />
              <span className="text-muted-foreground">Joined {user?.joinDate}</span>
            </div>
          </div>
        </div>

       <div className="flex flex-col items-center sm:items-end gap-2 flex-shrink-0">
          <div className="bg-accent text-accent-foreground px-3 py-1 rounded-full text-sm font-medium">
            {rankName || 'Bookworm Novice'}
          </div>
          <button
            onClick={() => setIsEditOpen(true)}
            className="flex items-center gap-1 text-xs text-muted-foreground hover:text-accent transition-colors"
          >
            <Icon name="Pencil" size={12} />
            Edit profile
          </button>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 pt-4 border-t border-white/40">
        <h3 className="text-sm font-medium text-foreground mb-3">Recent Achievements</h3>
        <div className="flex gap-2 sm:gap-3 overflow-x-auto pb-2 -mx-1 px-1">
          {displayAchievements?.map((achievement) => (
            <div
              key={achievement?.id}
              className="flex-shrink-0 flex items-center gap-2 bg-white/40 backdrop-blur-md px-3 py-2 rounded-lg whitespace-nowrap"
            >
              <Icon name={achievement?.icon} size={16} className={achievement?.color} />
              <span className="text-sm text-foreground">{achievement?.name}</span>
            </div>
          ))}
        </div>
      </div>

      <EditProfileModal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        user={user}
        onSaved={onProfileUpdate}
      />
    </div>
  );
};

export default ProfileSummaryCard;